import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {graphql} from "react-apollo/lib/index";
import ImportScanMutation from "../../graphql/ImportScanMutation.graphql";

@graphql(
	ImportScanMutation, {
		name: 'import'
	}
)
export default class ImportButton extends Component {

	static propTypes = {
		text: PropTypes.string,
		data: PropTypes.object,
		isDisabled: PropTypes.bool,
		labelsToImport: PropTypes.array,
		isScannedLabels: PropTypes.bool,
		defaultLanguage: PropTypes.string,
		selectedProject: PropTypes.object,
		afterImportCallback: PropTypes.func
	};

	importScan(){
		this.props.import({
			variables: {
				input: {
					scannedLabelIdentifiers: this.props.labelsToImport,
					isScannedLabels: this.props.isScannedLabels,
					defaultLanguage: this.props.defaultLanguage?this.props.defaultLanguage:""
				}
			}
		}).then(
			result => {
				this.props.data.refetch({
					variables: {
						project: this.props.selectedProject.name
					}});
				this.props.afterImportCallback();
			},
			error => {

			}
		)
	}

	render() {

		const {isDisabled, labelsToImport} = this.props;

		return (
			<button
				disabled={isDisabled  || this.props.defaultLanguage === "" || labelsToImport.length === 0}
				onClick={() => this.importScan(labelsToImport, true, "new")}
				className="btn btn-success">
									  <span className="btn-label">
										<i className="nc-icon nc-check-2"/>
									  </span>
				{this.props.text} ({labelsToImport.length})
			</button>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/ImportButton.js